import * as Tasks from 'Modules/TaskModule';
import { Task } from '../EnumTypes/ActionEnumTypes';

const init = () => ({
  type: Task.GET_TASKS_BY_LESSON_INIT,
});

export const success = (data) => ({
  type: Task.GET_TASKS_BY_LESSON_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: Task.GET_TASKS_BY_LESSON_FAILURE,
});

const getTasks = (uuid) => async (dispatch) => {
  dispatch(init());
  try {
    const response = await Tasks.Connector.getTasks(uuid);
    dispatch(success(response.data.lesson));
    return response.data;
  } catch (err) {
    dispatch(failure());
    return false;
  }
};

export default getTasks;
